// extracted by mini-css-extract-plugin
module.exports = {"form-row":"SaveSearchDialog_form-row__1iY3d","message":"SaveSearchDialog_message__3s3m_"};